export const STALE_ASSET_RELOAD_KEY = 'intrahub-static-reload';

export function isStaleChunkError(error) {
	const msg = String((error && error.message) || error || '');
	const name = (error && error.name) || '';
	return /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(
		`${name} ${msg}`
	);
}

/**
 * After a deploy, the running tab still has the old webpack runtime and will
 * request hashed /static/* files that no longer exist. Force one cache-busting
 * navigation so the browser picks up the new index.html.
 */
export function reloadOnStaleAssets() {
	if (process.env.NODE_ENV !== 'production') {
		return false;
	}

	const last = Number(sessionStorage.getItem(STALE_ASSET_RELOAD_KEY) || 0);
	if (Date.now() - last < 10000) {
		return false;
	}

	sessionStorage.setItem(STALE_ASSET_RELOAD_KEY, String(Date.now()));

	if (window.caches?.keys) {
		caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))).catch(() => {});
	}

	const url = new URL(window.location.href);
	url.searchParams.set('_cb', String(Date.now()));
	window.location.replace(url.toString());
	return true;
}
